<div class="text-input">
  <input type="text"
         [placeholder]="placeholder"
         [(ngModel)]="value"
         [ngClass]="{ 'filled': value.length }"
         (blur)="updateText()"
         (keyup.enter)="updateText()">
  <div *ngIf="value.length" class="clear-icon" (click)="handleClearValue();">x</div>
</div>
